import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IError } from 'src/app/models/error.model';
import { setWarningText } from 'src/app/reducers/warning-popup.reducer';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.sass']
})
export class ForgotPasswordComponent implements OnInit {
  loading = false;

  forgotPasswordForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    private router: Router,
    private loginService: LoginService,
    private store: Store<{ warningPopup: IError }>
  ) {}

  ngOnInit(): void {}

  navigateToLanding(): void {
    this.router.navigate(['/']);
  }

  navigateToLogin(): void {
    this.router.navigate(['/login']);
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    const email = this.forgotPasswordForm.value.email?.trim().toLowerCase();

    this.loginService.forgotPassword(email)
      .then(() => {
        // Navega para a tela de verificação de código passando o email
        this.router.navigate(['/verify-code'], { queryParams: { email } });
      })
      .catch((error) => {
        this.store.dispatch(setWarningText(error?.message || 'Erro ao enviar email. Tente novamente.'));
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
